import { Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

function QuickApplyLayout() {
  return (
    <>
      <Helmet>
        <title>Quick Apply</title>
        <link
          rel="preload"
          as="font"
          type="font/otf"
          href="/Assets/Fonts/GothamRounded-Light.otf"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          as="font"
          type="font/otf"
          href="/Assets/Fonts/GothamRounded-LightItalic.otf"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          as="font"
          type="font/otf"
          href="/Assets/Fonts/GothamRounded-Book.otf"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          as="font"
          type="font/otf"
          href="/Assets/Fonts/GothamRounded-Medium.otf"
          crossOrigin="anonymous"
        />
        <link
          rel="preload"
          as="font"
          type="font/ttf"
          href="/Assets/Fonts/GothamRoundedBold_21016.ttf"
          crossOrigin="anonymous"
        />
      </Helmet>
      <div>
        <main>
          <Outlet />
        </main>
      </div>
    </>
  );
}

export default QuickApplyLayout;
